export const greensparkAPI = () => {
    const selectors = {
        greensparkSection: '[data-greenspark]',
        typedText: '[data-typed-text]',
        typedTextItems: 'data-typed-text-items',
        cursor: '[data-cursor]',
        numberCounter: '[data-number-counter]',
        value: 'value',
        treesStatContainer: '[data-greenspark-trees]',
        treesPlaceholder: '[data-greenspark-trees-placeholder]',
        carbonStatContainer: '[data-greenspark-carbon]',
        carbonPlaceholder: '[data-greenspark-carbon-placeholder]',
    };
    const classes = {
        typing: 'cursor--typing',
    };
    const greensparkSections = document.querySelectorAll(selectors.greensparkSection);
    greensparkSections.forEach((section) => {
        const typedTextSpan = section.querySelector(selectors.typedText);
        const cursorSpan = section.querySelector(selectors.cursor);
        const textArray = typedTextSpan === null || typedTextSpan === void 0 ? void 0 : typedTextSpan.getAttribute(selectors.typedTextItems).split(',');
        const counters = document.querySelectorAll(selectors.numberCounter);
        const speed = 600;
        if (typedTextSpan && textArray && cursorSpan) {
            const typingDelay = 100;
            const erasingDelay = 100;
            const newTextDelay = 2000; // Delay between current and next text
            let textArrayIndex = 0;
            let charIndex = 0;
            const type = () => {
                if (charIndex < textArray[textArrayIndex].length) {
                    if (!cursorSpan.classList.contains(classes.typing))
                        cursorSpan.classList.add(classes.typing);
                    typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
                    charIndex++;
                    setTimeout(type, typingDelay);
                }
                else {
                    cursorSpan.classList.remove(classes.typing);
                    setTimeout(erase, newTextDelay);
                }
            };
            const erase = () => {
                if (charIndex > 0) {
                    if (!cursorSpan.classList.contains(classes.typing))
                        cursorSpan.classList.add(classes.typing);
                    typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex - 1);
                    charIndex--;
                    setTimeout(erase, erasingDelay);
                }
                else {
                    cursorSpan.classList.remove(classes.typing);
                    textArrayIndex++;
                    if (textArrayIndex >= textArray.length)
                        textArrayIndex = 0;
                    setTimeout(type, typingDelay + 1100);
                }
            };
            setTimeout(type, newTextDelay + 250);
        }
        // API
        const options = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                'x-api-key': 'qh%2FlzzYfqCE4ou6VYhvelCOYEhICJ3h32JDGjmlpWxJhK7RmazOjEA48fnG%2BkNnCLBUGYQU81qkE',
            },
            body: JSON.stringify({ color: 'green' }),
        };
        fetch('https://api.getgreenspark.com/widgets/stats-widget?lng=en', options)
            .then((response) => {
            return response.text();
        })
            .then((response) => {
            const htmlObject = document.createElement('div');
            htmlObject.innerHTML = response;
            const statsContainers = htmlObject.querySelectorAll('.gs-stats-label');
            if (statsContainers) {
                statsContainers.forEach((container) => {
                    var _a, _b;
                    const contentArr = container.innerHTML.split(' ');
                    let number = contentArr[0];
                    if (contentArr.includes('tree') || contentArr.includes('trees')) {
                        const cleaned = number.replace(',', '');
                        (_a = section.querySelector(selectors.treesStatContainer)) === null || _a === void 0 ? void 0 : _a.setAttribute('value', cleaned);
                        const treesEl = section.querySelector(selectors.treesPlaceholder);
                        if (treesEl)
                            treesEl.textContent = cleaned;
                    }
                    if (contentArr.includes('carbon') || contentArr.includes('CO2')) {
                        number = Math.round(number);
                        (_b = section.querySelector(selectors.carbonStatContainer)) === null || _b === void 0 ? void 0 : _b.setAttribute('value', number);
                        const carbonEl = section.querySelector(selectors.carbonPlaceholder);
                        if (carbonEl)
                            carbonEl.textContent = String(number);
                    }
                });
            }
        })
            .then(() => {
            counters.forEach((counter) => {
                const animate = () => {
                    const value = +counter.getAttribute(selectors.value);
                    // @ts-ignore
                    const data = +counter.innerText;
                    const time = value / speed;
                    if (data < value) {
                        // @ts-ignore
                        counter.innerText = Math.ceil(data + time);
                        setTimeout(animate, 1);
                    }
                    else {
                        // @ts-ignore
                        counter.innerText = value;
                    }
                };
                const observer = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (entry.isIntersecting) {
                            animate();
                        }
                    }
                });
                observer.observe(counter);
            });
        });
    });
};
